// import '../lightgallery/jquery-lightgallery';
// import '../lightgallery/jquery-lightgallery-additional';
// import '../lightgallery/jquery-lightgallery-aside';
// import '../lightgallery/jquery-lightgallery-custom-content';
// import '../lightgallery/jquery-lightgallery-topside';
import '../msnt/msnt-lightslider';

import {
  executeAsync,
  getGallerysCollection,
  openCommentsDrawer,
} from '../utils/fn';
// import { initCoralComments } from '../utils/fn';
// import { type } from 'jquery';
import { initCoralComments } from '../comments/comments';

export const msntPhotoThumbGallery = (selector) => {
  var selector = selector || '.msnt-photo-thumb-gallery';
  var $dataEdtn = $('body').data('edtn');

  $(selector + ' .msnt-photo-thumb-gallery-photos-list').lightSlider({
    pager: false,
    autoWidth: true,
    rtl: $('body').data('rtl'),
    slideMargin: 5,
    enableDrag: false,
    hideControlsAtEdges: true,
    onSliderLoad: function ($el) {
      if ($el.data('slider-hash')) {
        var fragment = document.location.hash.replace(/[^a-zA-Z_0-9-/#]/g, '');
        if (fragment) {
          var isFullSize = fragment.lastIndexOf('#full-size/');
          if (isFullSize !== -1) {
            fragment = fragment.substr(0, isFullSize);
            if (fragment === '') {
              history.replaceState(
                {},
                null,
                document.location.href.replace('#full-size/', ''),
              );
              setTimeout(function () {
                $(selector)
                  .find('.msnt-photo-thumb-gallery-main-photo-box')
                  .trigger('click');
              }, 10);
            } else {
              history.replaceState(
                {},
                null,
                document.location.href.replace('#full-size/', ''),
              );
            }
            isFullSize = true;
          } else {
            isFullSize = false;
          }
          // if (fragment) {
          var $currentSlide = $el.find('[data-hash="' + fragment + '"]');
          isFullSize = true;
          if ($currentSlide.length) {
            var $mainPhoto = $(selector).find(
              '.msnt-photo-thumb-gallery-main-photo-box',
            );
            var $mainPhotoImage = $mainPhoto.find('img');
            var src = $currentSlide.data('src');
            var href = $currentSlide.data('url');
            if ($mainPhoto.length && $mainPhotoImage.length && src && href) {
              $el.goToSlide($currentSlide.index());
              $mainPhoto.attr('href', href);
              $mainPhotoImage.attr('src', src);
            }
            if (isFullSize) {
              setTimeout(function () {
                $currentSlide.trigger('click');
              }, 10);
            }
          } else {
            let loadPhotoId;
            let $galleryItemLast = $(
              '.msnt-photo-thumb-gallery-photos-list .lslide',
            ).last();
            let $gallery = $('.msnt-photo-thumb-gallery-photos-list').first();
            let match = fragment.match(/#(\d+)_/);
            if (match && match[1]) {
              loadPhotoId = match[1];
            } else {
              console.log('No such photo id!');
            }

            let photoIds = $gallery.data('photo-ids').split(',');
            if (photoIds.includes(loadPhotoId)) {
              $galleryItemLast.attr('data-load-photo-hash', loadPhotoId);
              setTimeout(function () {
                $galleryItemLast.trigger('click');
              }, 10);
            } else {
              history.replaceState(
                {},
                null,
                document.location.href.replace(hash, ''),
              );
            }
          }
          // }
        }
      }
    },
  });

  let hash = document.location.hash,
    gallerys = document.querySelectorAll(
      '.msnt-photo-thumb-gallery-photos-list',
    ),
    $sectionImg;

  //'#comments-block-wrapper' replace selector below with that
  const commentsBlockToScroll = document.querySelector('#comments');
  if (hash && !gallerys[0]?.dataset.sliderHash) {
    let dataHash = hash.replace(/[^a-zA-Z_0-9-\/]/g, ''),
      arrayOfHash = dataHash.split('/'),
      galleryCollection = getGallerysCollection(gallerys, arrayOfHash[1], null);
    //'#comments-block-wrapper' replace selector below with that
    if (dataHash == 'comments') {
      const dataEdtn = document.body.dataset.edtn;
      const coralContainer = $('#coral_thread_app');
      let coralCommentsLoaded = false;

      history.replaceState({}, null, document.location.href.replace(hash, ''));
      openCommentsDrawer();
      if (!coralCommentsLoaded) {
        coralCommentsLoaded = true;
        initCoralComments();
      }
      import(/* webpackPrefetch: true */ '../../common/utils/comments').then(
        (module) => {
          module.initComments(coralContainer, dataEdtn);
        },
      );
      // let counterIsCalled = 1;

      // setTimeout(() => {
      //   window.scrollTo(0, 0);
      // }, 0);
      // var distanceToAnchor = $(hash).offset().top;
      // var distanceToAnchorNew;
      // var callTimes = 0;
      // console.log(distanceToAnchor);

      // commentsBlockToScroll.scrollIntoView({ behavior: 'smooth' });

      const url = new URL(window.location.href);

      if (url.searchParams.has('commentsLogin')) {
        url.searchParams.delete('commentsLogin');
        openCommentsDrawer();
        if (!coralCommentsLoaded) {
          coralCommentsLoaded = true;
          initCoralComments();
        }

        // const triggerCoralBtn = document.querySelector('.show-coral');
        // triggerCoralBtn.click();

        window.history.replaceState(
          null,
          null,
          `${url.pathname}${url.search}${url.hash}`,
        );
      }

      /*const resizeObserver = new ResizeObserver((entries, observer) => {
        for (let entry of entries) {
          if (callTimes < 8) {
            calcResizeTimes();
          } else {
            resizeObserver.unobserve(document.querySelector('#post_box'));
            resizeObserver.unobserve(
              document.querySelector('#container_3rd_party_service'),
            );
          }
        }
      });

      resizeObserver.observe(document.querySelector('#post_box'));
      resizeObserver.observe(
        document.querySelector('#container_3rd_party_service'),
      );

      resizeObserver.observe(document.querySelector('#post_box'));
      resizeObserver.observe(
        document.querySelector('#container_3rd_party_service'),
      );

      function calcResizeTimes() {
        distanceToAnchorNew = $(hash).offset().top - 80;

        if (distanceToAnchor != distanceToAnchorNew) {
          // $('html, body').animate({
          //   scrollTop: distanceToAnchorNew
          // }, 500);
          commentsBlockToScroll.scrollIntoView({ behavior: 'smooth' });
        }
        callTimes++;
      }*/
    }

    history.replaceState({}, null, document.location.href.replace(hash, ''));

    if (!galleryCollection) return;

    let galleryId = galleryCollection.galleryId;

    if (galleryId == null) {
      let photoId = galleryCollection.photoIds;

      $sectionImg = $(
        'section[data-widget="image"][data-id="' + photoId + '"]',
      ).first();

      executeAsync(() => {
        $sectionImg.trigger('click');
      });
    }

    let $gallery = $(
        '.msnt-photo-thumb-gallery-photos-list[data-galleryid="' +
          galleryId +
          '"]',
      ).first(),
      $galleryItem = $gallery.find(
        '.lslide[data-entity-id="' + arrayOfHash[1] + '"]',
      ),
      $galleryItemFirst = $(
        '.msnt-photo-thumb-gallery-photos-list[data-galleryid="' +
          galleryId +
          '"] .lslide',
      ).first(),
      offsetTop;

    const hashParts = hash.split('#');
    const cleanedParts = hashParts
      .map((part) => part.replace(/\//g, ''))
      .filter((part) => part !== '');
    const anchorImgDataId =
      cleanedParts[0] === 'null' ? cleanedParts[1] : cleanedParts[0];

    const imgAnchorElement = $('[data-id="' + anchorImgDataId + '"]');

    if (imgAnchorElement.length != 0) {
      offsetTop = imgAnchorElement.offset().top - 60;
    } else if ($gallery.length != 0) {
      offsetTop = $gallery.closest('.msnt-photo-thumb-gallery').offset().top;
    } else {
      offsetTop = $('#container_3rd_party_service').offset().top;
    }

    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }

    if (dataHash !== 'comments') {
      $('html, body').animate(
        {
          scrollTop: offsetTop,
        },
        0,
      );
    }

    if ($gallery.length != 0) {
      $gallery.attr({
        'data-ampgalleryid': galleryId,
        'data-ampphotoid': arrayOfHash[1],
      });

      executeAsync(() => {
        let itemClick =
          $galleryItem.length != 0 ? $galleryItem : $galleryItemFirst;
        itemClick.trigger('click');
      });
    }
  }
};
